import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {BaseComponent} from "../../BaseComponent";
import {PartitionOpeService} from "../../../services/ope/partitionOpe.service";
import {Partition} from "../../../models/partition/Partition";
import {GetPartitionHierarchyCB} from "../../../ope/partition/GetPartitionHierarchyCB";
import {DashboardService} from "../../../services/dashboard/dashboard.service";

@Component({
  selector: 'app-partition-selector',
  templateUrl: './partition-selector.component.html',
  styleUrls: ['./partition-selector.component.css']
})
export class PartitionSelectorComponent extends BaseComponent implements OnInit {

  partitionService: PartitionOpeService = inject(PartitionOpeService);
  @Input() disabled!: boolean;
  @Output() protected selectedPartitionChange = new EventEmitter();
  @Output() protected partitionIsConnectedChange = new EventEmitter<boolean>();
  /**
   * Service containing the shared data and procedures among dashboard components
   * @protected
   */
  protected dashboardService = inject(DashboardService);

  private _selectedPartition!: number | null;

  get selectedPartition(): number | null {
    return this._selectedPartition;
  }

  @Input() set selectedPartition(value: number | null) {
    this._selectedPartition = value;
    const fullPartition = this.dashboardService.partitions.find(partition => partition.id === this._selectedPartition);
    this.partitionIsConnectedChange.emit(fullPartition?.isConnected ?? false);
  }

  ngOnInit() {
    super.ngOnInit();
    this.selectedPartitionChange.emit(this.selectedPartition);
    this.getPartitionHierarchy();
  }

  /**
   * Get all partitions
   */
  getPartitionHierarchy() {

    const cb = new GetPartitionHierarchyCB();
    this.partitionService.getPartitionHierarchy(cb).then((_) => {
      this.dashboardService.partitions = cb.o.partitions;
      const partitionIds: number[] = this.dashboardService.partitions.map(c => c.id);
      this.dashboardService.partitions.forEach((partition: Partition, index, array) => {
        if (!!partition.parentId && !partitionIds.includes(partition.parentId)) {
          partition.parentId = 0;
          partition.isConnected = true;
        } else {
          partition.isConnected = false;
        }
        if (this.selectedPartition === partition.id) {
          this.partitionIsConnectedChange.emit(partition.isConnected);
        }
      })
    }).catch((error) => {
      this.dashboardService.partitions = [];
    });
  }

}
